
import { DomainTag, ExistingPrimitiveTagType } from "./domain/domainTag";

let isDomainTagInitialized = false;

export function ensureDomainTag() {
    if (isDomainTagInitialized) return;
    isDomainTagInitialized = true;
    const domainTagInstance = new DomainTag();
    domainTagInstance.isInitialized = true;

    const existingTag = (window.domainTag as ExistingPrimitiveTagType);
    window.domainTag = domainTagInstance;
    if (existingTag) {
        domainTagInstance.isRegen = true;
        while (existingTag.cmd && existingTag.cmd.length > 0) {
            const cmdFunc = existingTag.cmd.shift();
            if (cmdFunc) {
                domainTagInstance.cmd.push(cmdFunc);
            }

        }
    }
    //domainTagInstance.processQueue();

}



